import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';
import type { PublishModalKeyboardShortcutsProps } from '../src/PublishModalKeyboardShortcuts.tsx';

export const PublishModalKeyboardShortcuts: LoadableType<PublishModalKeyboardShortcutsProps> =
	LoadableLazy({
		loader: async () => {
			return (
				await import(
					/* webpackChunkName: "loadable-PublishModalKeyboardShortcuts" */ '../src/PublishModalKeyboardShortcuts.tsx'
				)
			).PublishModalKeyboardShortcuts;
		},
	});
